import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../../components';
import { InteractiveButton } from '../../../../../components';
import iconError from '../../../../../../../../assets/illustrations/error-files.svg';

interface PseSuccessProps {
  handleClick: () => void;
  title: string;
  subtitle: string;
}
const ErrorModalPSE: React.FC<PseSuccessProps> = (props) => {
  const { handleClick, title, subtitle } = props;
  return (
    <Block
      data-testid="cmp-modal-pse-error"
      customized
      maxWidth={isMobile ? '100%' : '496px'}
      backgroundColor="#fff"
      padding="0px 32px 32px 32px"
      margin="8px 0px 0px 0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <img
        src={iconError}
        alt="error"
        style={{
          marginBottom: 8
        }}
      />
      <Heading
        text={`${title}`}
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        align="center"
        width="100%"
      />
      <span
        style={{
          fontSize: '14px',
          fontWeight: '400',
          marginTop: 12,
          marginBottom: 12,
          textAlign: 'center'
        }}
      >
        {subtitle}
      </span>
      <div
        style={{
          padding: window.innerWidth < 400 ? 12 : 0,
          display: 'flex',
          flexDirection: window.innerWidth < 400 ? 'column' : 'row',
          marginTop: 24,
          width: 297,
          alignItems: 'center',
          justifyContent: window.innerWidth < 400 ? 'center' : 'space-around'
        }}
      >
        <InteractiveButton
          data-testid="btn-success-pse-modal"
          bkgColorEnabled="#5B36F2"
          bkgColorHover="#745EF6"
          bkgColorFocus="#4318CD"
          bkgColorPressed="#4318CD"
          customized
          as="button"
          alignItems="center"
          backgroundColor="#5B36F2"
          padding="9px 4px"
          margin="0px 0px 0px 0px"
          borderRadius="4px"
          width={'100%'}
          onClick={() => handleClick()}
        >
          <Text
            color="#FFFFFF"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="700"
            textAlign="center"
          >
            Entendido
          </Text>
        </InteractiveButton>
      </div>
    </Block>
  );
};

export default ErrorModalPSE;
